import React from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  { name: 'About', path: '/about-us' },
  { name: 'Ambassadors', path: '/our-ambassadors' },
  { name: 'Apply', path: '/apply' },
  { name: 'Join the Team', path: '/join-the-team' },
  { name: 'Events', path: '/events' },
];

const Footer = () => {
  return (
    <footer className="bg-cream border-t border-dark-green/15 pb-24 sm:pb-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Top row: get in touch + email */}
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-baseline py-12 md:py-16">
          <div className="md:col-span-4">
            <p className="font-mono tracking-[0.25em] text-[10px] sm:text-xs uppercase text-dark-green/55 mb-3">
              <span className="text-dark-green/35">&rarr;</span> Get in touch
            </p>
            <p className="font-serif text-dark-green/55 text-base md:text-lg leading-snug max-w-xs">
              Have a question, idea, or proposal? We&rsquo;re listening.
            </p>
          </div>
          <div className="md:col-span-8">
            <a
              href="mailto:info@dharmainitiative.org.uk"
              data-testid="footer-email-link"
              className="group inline-flex items-baseline gap-2 sm:gap-3 max-w-full font-serif text-xl sm:text-3xl md:text-4xl lg:text-5xl text-dark-green leading-tight transition-colors duration-300 hover:text-dark-green/70 break-all"
            >
              <span className="break-all">info@dharmainitiative.org.uk</span>
              <span aria-hidden className="text-lg sm:text-2xl shrink-0 group-hover:translate-x-1 transition-transform duration-300">&rarr;</span>
            </a>
          </div>
        </div>

        {/* Bottom row: navigation + copyright */}
        <div className="border-t border-dark-green/15 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-dark-green/55">
            The Dharma Initiative &copy; 2026
          </p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Footer">
            {footerLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="font-mono text-[11px] tracking-[0.2em] uppercase text-dark-green/55 hover:text-dark-green transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
